export default function Features() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50" id="features">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left - Image */}
          <div className="lg:w-2/5">
            <div className="rounded-3xl overflow-hidden bg-secondary-100 aspect-[4/5] relative">
              <img
                src="https://readdy.ai/api/search-image?query=A%20laptop%20screen%20displaying%20a%20beautifully%20organized%20product%20data%20spreadsheet%20with%20colorful%20category%20tags%20on%20a%20modern%20standing%20desk%2C%20indoor%20plant%20beside%20the%20laptop%2C%20warm%20afternoon%20light%20through%20sheer%20curtains%2C%20contemporary%20home%20office%2C%20clean%20productive%20atmosphere%2C%20editorial%20workspace%20photography&width=800&height=1000&seq=features-v2-dash-2026&orientation=portrait"
                alt="ItaobuySpreadsheet structured data dashboard"
                title="ItaobuySpreadsheet - Structured Product Sourcing Dashboard"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right - Content */}
          <div className="lg:w-3/5 flex flex-col justify-center">
            <span className="text-xs font-medium text-foreground-500 tracking-wider mb-4">
              ( Core Features )
            </span>
            <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-[1.15] mb-8">
              <span className="block font-bold">Built for</span>
              <span className="block font-light text-foreground-500">Resellers</span>
            </h2>

            <div className="space-y-6">
              <div className="flex gap-4">
                <span className="text-accent-500 mt-0.5 flex-shrink-0">
                  <i className="ri-checkbox-circle-line text-xl"></i>
                </span>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-950">Structured Product Spreadsheet Database</h4>
                  <p className="text-sm text-foreground-600 mt-1">Clean, organized data that is easy to parse and act upon immediately.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <span className="text-accent-500 mt-0.5 flex-shrink-0">
                  <i className="ri-checkbox-circle-line text-xl"></i>
                </span>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-950">Multi-Category Sourcing System</h4>
                  <p className="text-sm text-foreground-600 mt-1">14 product categories covering everything from shoes to perfumes.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <span className="text-accent-500 mt-0.5 flex-shrink-0">
                  <i className="ri-checkbox-circle-line text-xl"></i>
                </span>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-950">Fast Filtering & Navigation</h4>
                  <p className="text-sm text-foreground-600 mt-1">Spend less time searching and more time growing your business.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <span className="text-accent-500 mt-0.5 flex-shrink-0">
                  <i className="ri-checkbox-circle-line text-xl"></i>
                </span>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-950">Beginner-Friendly Layout</h4>
                  <p className="text-sm text-foreground-600 mt-1">Intuitive design that anyone can start using within minutes.</p>
                </div>
              </div>
            </div>

            <p className="mt-8 text-sm text-foreground-500 italic border-l-2 border-primary-300 pl-4">
              &mdash; itaobuy sheet system
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}